// 请求失败原因类型
export const EnumRequestFailReasonType = Object.freeze({
  // 未登录
  NOT_LOGIN: 1
})



// WEBPACK FOOTER //
// ./src/constants/login.js